export default "__VITE_ASSET__BjtpbPBl__"